import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['expiration'];
  static values = {
    secondsRemaining: String,
    endsAt: Number // Epoch time in seconds
  };

  initialize() {
    if (!this.hasExpirationTarget) {
      return;
    }

    const defaultSeconds = 1;
    const defaultMinutes = defaultSeconds * 60;
    const defaultHours = defaultMinutes * 60;
    const defaultDays = defaultHours * 24;
    let calculatedHours, calculatedMinutes, calculatedSeconds;

    let timeRemaining = null;
    if (this.hasSecondsRemainingValue) {
      timeRemaining = this.secondsRemainingValue;
    } else if (this.hasEndsAtValue) {
      let epochTimeInSeconds = Date.now() / 1000;
      timeRemaining = this.endsAtValue - epochTimeInSeconds;
    }

    setInterval(() => {
      if (timeRemaining < 0) {
        clearInterval();
        return;
      }

      calculatedHours = Math.floor((timeRemaining % defaultDays) / defaultHours)
        .toString()
        .padStart(2, '0');
      calculatedMinutes = Math.floor(
        (timeRemaining % defaultHours) / defaultMinutes
      )
        .toString()
        .padStart(2, '0');
      calculatedSeconds = Math.floor(
        (timeRemaining % defaultMinutes) / defaultSeconds
      )
        .toString()
        .padStart(2, '0');

      if (calculatedSeconds < 10) {
        calculatedSeconds.padStart(2, '0');
      }

      this.expirationTarget.innerHTML = `${calculatedHours}:${calculatedMinutes}:${calculatedSeconds}`;
      timeRemaining -= 1;
    }, 1000);
  }
}
